import React from "react";
import { RuleOfWeek } from "../../../types/models/RuleOfWeek";
import { Box, ListItem, ListItemText, Typography } from "@mui/material";
import { fontColor } from "../../../constants/ColorSets";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/store";
import { RuleUnitState } from "../../../types/models/RuleUnitState";

interface RuleOfWeekItemProp {
  ruleOfWeek: RuleOfWeek;
  isSelected: boolean;
  onViewParagraph: (ruleOfWeek: RuleOfWeek) => void;
}

const RuleOfWeekItem: React.FC<RuleOfWeekItemProp> = ({
  ruleOfWeek,
  isSelected,
  onViewParagraph,
}) => {
  const ruleUnitState = useSelector<AppState, RuleUnitState>((state) => state.ruleUnit);

  const getParentNameForRule = () => {
    const contentRevision = (ruleUnitState.baseContentRevisionDetails ?? [])
      .concat(ruleUnitState.baseSupportDocumentContentRevisionDetails ?? [])
      .find((detail) =>
        detail.RuleInstances?.some((rule) => rule.RuleInstanceId === ruleOfWeek.RuleInstanceId)
      );

    if (contentRevision && contentRevision.Taxonomy && contentRevision.Taxonomy.length > 0) {
      // Remove num + # prefix, and replace ";" separator to ">"
      const displayTaxonomy = contentRevision?.Taxonomy.replace(/^\d+#/, "").replace(";", " >");
      return displayTaxonomy + " > " + contentRevision?.DisplayName;
    } else {
      return ruleOfWeek.DisplayName;
    }
  };

  const getDisplayNameElement = (displayName: string, isSelected: boolean) => {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-start", alignContent: "center" }}>
        <Typography
          sx={{
            fontWeight: isSelected ? 600 : (ruleOfWeek.Read ? "" : 500),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: ruleOfWeek.Read ? "" : "white",
          }}
        >
          {displayName}
        </Typography>
      </Box>
    );
  };

  return (
    <ListItem
      className="item-hover"
      data-element="RulesOfWeek_Item"
      onClick={() => onViewParagraph(ruleOfWeek)}
      sx={{
        background: ruleOfWeek.Read
          ? isSelected
            ? fontColor.orangeHoverBackground
            : ""
          : isSelected
          ? fontColor.ruleOfWeekSelected
          : fontColor.ruleOfWeekBackground,
        pl: 2,
        pr: 1,
        py: 0.5,
        cursor: "pointer",
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
        backgroundBlendMode: "overlay",
        borderRadius: 0.5,
        display: "block",
        borderBottom: (theme) => `solid 1px ${theme.palette.grey[300]}`,
        "&:hover, &:focus": {
          background: ruleOfWeek.Read ? fontColor.orangeHoverBackground : fontColor.ruleOfWeekHover,
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <ListItemText
          primary={getDisplayNameElement(ruleOfWeek.DisplayName, isSelected)}
          secondary={getParentNameForRule()}
          secondaryTypographyProps={{
            style: {
              marginTop: "4px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: ruleOfWeek.Read ? "" : fontColor.ruleOfWeekSubTitle,
            },
          }}
        ></ListItemText>
      </Box>
    </ListItem>
  );
};

export default RuleOfWeekItem;
